import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ControlloIntegritaComponent} from './controllo-integrita';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.controllo-integrita', {
      url: '/controllo-integrita',
      ncyBreadcrumb: {
        label: 'Controllo Integrità',
        parent: 'home.admin',
      },
      data: {
        authorisationLevel: 2,
        pageTitle: 'Controllo Integrità'
      },
      'views': {
        'homeContent': {
          template: '<controllo-integrita flex="100"></controllo-integrita>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const ControlloIntegritaModule: string = ng
  .module('controllo-integrita', [
    'ui.bootstrap',
    uiRouter,
  ])
  .component('controlloIntegrita', ControlloIntegritaComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/controllo-integrita/controllo-integrita.module.ts